import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class Keynote2 extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">
            <div className="new_banner">
            <div className="banner_content">
              <h1>LLM 2025</h1>
              
              <h6>The 2025 International Conference on Large Language Models (LLM)</h6>
              <h6>December 3-5, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
            <h4 className="par_header">Keynotes/Invited Lectures</h4>
            <br />
            <div style={{textAlign: "center"}}>
            <b>From AI Agents to Agentic AI: A Practical Path for
S&OP-Centric Supply Chain Optimization
</b> <br/>
            <br />Beilei Zhu <br/>
            Intel, Corporation, USA<br />
            </div>
        
            <h6 className="par_header">Abstract:</h6>
            <div className="par">
            Global supply chains are vulnerable to ongoing distribution shift-demand shocks, policy interventions, and geopolitical surprises-that disrupt fixed plans and expose the limitations of purpose-built automation. We place Sales and Operations Planning (S&OP) as a control loop use case that combines learned predictors and simple rules: forecast → set inventory targets → size/time buys →roll up spend, subject to invariants such as stockout-risk service levels (through safety buffers), discipline to moderate bullwhip amplification, coordination among heterogeneous actors, and minimum order quantities and casepack increments in monthly budget constraints. We contribute Agentic AI as the level that orchestrates these steps, checks invariants after each step, and replans online when inputs move, unveiling typed interfaces, schema-based I/O (Input /Output), and auditable traces rather than dark-box end states. Two interchangeable runtimes serve different adoption modes: a one-process OpenAI SDK orchestrator for low latencies, and a protocolized services architecture in MCP (Model Context Protocol) terms for capability discovery and typed, schema-based I/O beyond teams. In controlled replays in synthetic yet representative plan-to-procure scenarios, Agentic AI reduces constraint violations and cycle time and improves service and adherence to monthly caps, along with readable explanations of why the ultimate plan assumes its shape. Grounded in inventory theory, bullwhip mitigation, agent-based views, procurement optimization, and current tool-orchestration practice, it marks a practical advance toward a coherent, end-to-end planning capability from local point solutions.
            </div>

            <h6 className="par_header">Speaker’s Biography:</h6>
            <div className="par">
            Beilei Zhu is a proven leader in the world supply chain and artificial intelligence innovation. As a Staff Data Scientist at Intel with over 17 years of experience, she has led Analytics and AI-powered solutions that have transformed supply-demand planning, sourcing, and inventory optimization—with millions in cost reduction and improved resilience in dynamic markets.
            <br/> <br/>
            Beilei has published at Springer Nature and IEEE in fields related to AI applications specialized for Supply chain process optimization. Known for pioneering supply chain analytics innovation and a mentoring passion, she motivates business groups to employ AI for wiser decisions, improved operations, and sustainable development.
            <br/> <br/>
            <div style={{textAlign: "center"}}>
                <img src="/static/Zhu.jpg" height="300px" alt=""/>
            </div>
            </div>          
          </div>
          

        </div>
      </div>
    );
  }
}

export default Keynote2;